export class MenuItem {
    id: string;
    title: string;
    url: string;
    position: number;
    icon?: string;
    children?: Array<MenuItem>;
}